module.exports = __webpack_public_path__ + "static/10-1a97e97f024c95a5c9442949ef254881.jpg";